import { render, staticRenderFns } from "./FmlCheckbox.vue?vue&type=template&id=b2838884&"
import script from "./FmlCheckbox.vue?vue&type=script&lang=js&"
export * from "./FmlCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports